import React, { useEffect, useState } from 'react'
import "./styles.css";
import { ReactComponent as Showpassword } from "common/assets/svg/showPassword.svg";
import { ReactComponent as Hidepassword } from "common/assets/svg/hidePassword.svg";
import DialCodePicker, { CountryCodeData } from 'components/dialCodePicker';
import { SignInForm } from 'common/features/auth/AuthModels';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { guestCart } from '../signIn';
import { validateField } from 'common/utils/field-validator';
import { GUEST_CART } from 'common/constants';
import { RootState } from 'common/rootReducer';
import { getMerchantHomeURL } from 'common/utils/route-util';
import { clearLocationAfterAuth, signIn } from "common/features/auth/AuthActions";
import PasswordError from 'components/PasswordError';
export interface AuthLoginInterface {
    handleOnPageSwitch:(key:string)=>void;
    handleLoginSuccess:(key:string)=>void;
  }

const AuthLogin = (props:AuthLoginInterface) => {

    const history = useHistory();
    const dispatch = useDispatch();
    const {handleOnPageSwitch,handleLoginSuccess} = props;

    const [showDialCodePicker, setShowDialCodePicker] = useState(false);
    const [countryData, setCountryData] = useState<CountryCodeData>({
        code: "+1",
        flag: "https://upload.wikimedia.org/wikipedia/en/a/a4/Flag_of_the_United_States.svg",
      });
    const [userId, setUserId] = useState("");
    const [isMobile, setIsMobile] = useState(false);
    const [isPasswordShown, setIsPasswordShown] = useState(false);
    const [formErrorMessage, setFormErrorMessage] = useState<string | null>(null);

    const authState = useSelector((state: RootState) => state.auth);
    const cart = useSelector((state: RootState) => state.cart);
    const toLocationAfterAuth = useSelector((state: RootState) => state.auth.toLocationAfterAuth);
    const cartURL = useSelector((state: RootState) => state.cart.cartURL);


    const {register,errors,handleSubmit,control,getValues,setValue,watch, formState,} = useForm<SignInForm>({defaultValues: {userId: "",password: "",},});

    useEffect(() => {
        if (!authState.signInLoading && authState.signedIn && formState.isSubmitted) {
          handleLoginSuccess('SUCCESS')
          // if (cart.isCartAuthPending) {
          //   history.push(cartURL);
          //   localStorage.removeItem(GUEST_CART);
          // } else if (toLocationAfterAuth) {
          //   const path = toLocationAfterAuth;
          //   dispatch(clearLocationAfterAuth());
          //   history.push(path);
          //   localStorage.removeItem(GUEST_CART);
          // } else {
          //   let data: guestCart = JSON.parse(
          //     localStorage.getItem(GUEST_CART) || ""
          //   );
          //   history.push(getMerchantHomeURL("restaurant", data.restaurantSlug));
          //   localStorage.removeItem(GUEST_CART);
          // }
        }
      }, [authState.signInLoading]);

      useEffect(() => {
        if (!authState.signInLoading && !authState.signedIn && formState.isSubmitted) {
          setFormErrorMessage(authState.signInMessage);
        }
      }, [authState]);

    const onSubmit = (data: SignInForm) => {
          data.userId = countryData.code + "-" + data.userId;
          data.password = data.password
        dispatch(signIn(data));
      };

  return (
    <React.Fragment>
        <div id="sign-in-screen">
           
            <form id="sign-in-form" onChange={()=>{setFormErrorMessage('')}} onSubmit={handleSubmit(onSubmit)}>
                <div id="text-box-container-ad" style={{ marginTop: "1rem",position:'relative' }}>
                    <label id="input-label">User ID</label>
                    <div id="signIn-text-box" style={{ marginTop: "0.5rem" }}>
                        <React.Fragment>
                        <img
                            alt="flag"
                            src={countryData.flag}
                            height={"14px"}
                            width={"21px"}
                            className="flag"
                            onClick={() => setShowDialCodePicker(!showDialCodePicker)}
                        />
                        &nbsp;
                        <span id="countryCode" onClick={() => setShowDialCodePicker(!showDialCodePicker)} >
                            {countryData.code}
                        </span>
                        </React.Fragment>
                        <input
                            type="text"
                            placeholder="Enter Mobile number"
                            name="userId"
                            ref={register(validateField("userId").isValidMobileNumber().isRequired().Rules)}
                            // onChange={(event) => {
                            // const validatedValue = event.target.value.replace(/[^0-9]/g, '').slice(0, 10);
                            // setUserId(validatedValue);
                            // }}
                             maxLength={10}
                            //value={userId} 
                            autoComplete="off"
                            className="mobile-detail"
                        />
                    </div>
                    <span id="error-msg">
                        {errors.userId && errors.userId.type === "required" && (
                            <span className="req-msg">User ID Required</span>
                        )}
                          {errors.userId && errors.userId.type === "pattern" && (
                            <span className="req-msg">Enter a Valid Mobile Number</span>
                        )}
                    </span>
                    <DialCodePicker
                      showPicker={showDialCodePicker}
                      setShowPicker={setShowDialCodePicker}
                      setCountryData={setCountryData}
                      inputValue={userId}
                      setIsMobile={setIsMobile}
                      onlyMobile={false}
                  />
                </div>

                <div id="text-box-container" style={{ marginTop: "1rem" }}>
                    <label className="input-label">Password</label>
                    <div id="signIn-text-box">
                        <input
                            style={{ fontSize: 13 }}
                            className="pwd"
                            type={isPasswordShown ? "text" : "password"}
                            name="password"
                            placeholder="Enter password"
                            autoComplete="off"
                            ref={register({
                              required: "Password is required",
                              minLength: {
                                value: 8,
                                message: "Password must be more than 8 characters long",
                              },
                              pattern: {
                                value: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_])[^\s]{8,}$/,
                                message: "Password must be alphanumeric, contain at least one uppercase letter, one special character and must not have spaces",
                              },
                            })}
                            //ref={register(validateField("password").isValidPassword().isRequired().Rules)}
                        />
                        {isPasswordShown ? (
                        <Hidepassword
                        className="hidePasswordSVG"
                        onClick={() => {
                            setIsPasswordShown(!isPasswordShown);
                        }}
                        />
                        ) : (
                        <Showpassword
                        className="showPasswordSVG"
                        onClick={() => {
                            setIsPasswordShown(!isPasswordShown);
                        }}
                        />
                        )}

                    </div>
                    <span id="error-msg">
                        {errors.password && errors.password.type === "required" && (
                            <span className="req-msg">Password Required</span>
                        )}
                         {errors.password && errors.password.type === "minLength" && (
                            <span className="req-msg">{errors.password.message}</span>
                        )}
                          {errors.password && errors.password.type === "pattern" && (
                            <PasswordError/>
                        )}
                    </span>
                </div>

                <div id="links-container">

                    <span id="signIn-forgot-password-link-c" onClick={() => { handleOnPageSwitch('FORGOT_PASSWORD')}} style={{ marginTop: "0", marginBottom: "0" }} >Forgot Password </span>
                    <span className="sign-up-form-error-msg desktop-login-form-error-msg"  style={{ marginBottom: "15px"}} > {formErrorMessage ? formErrorMessage : null} </span>
                    <button id="sign-in-button-ad"  type="submit"  style={{ width: 305 }}> 
                        {authState.signInLoading ? "Signing In" : "Sign in"} 
                    </button>

                    <div id="register-link">
                        <span>Don't have an account?</span>
                        &nbsp;
                        <span id="create-new-account"  onClick={() => {handleOnPageSwitch('REGISTER')}}> Create New Account</span>
                    </div>

                    <div id="register-link"style={{ marginTop: "8px", marginBottom: "16px" }}>
                        &nbsp;
                        <span id="create-new-account"  onClick={() => {handleOnPageSwitch('GUEST')}}>  Continue as a guest </span>
                    </div>
                </div>
            </form>
        </div>
    </React.Fragment>
  )
}

export default AuthLogin